import React from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import PageHeader from "../Components/Pageheader";
import "../assets/Css/shop.css";
import {
  seller1,
  seller2,
  seller3,
  seller4,
  shop1,
  shop2,
} from "../Constant/Index";
import { Link } from "react-router-dom";
import Pagination from "../Components/Pagination";

function Shop() {
  const sellerstuff = [
    {
      img: shop2,
      name: "product name",
      price: "$20",
      para: "We believe in natural beauty",
    },
    {
      img: shop1,
      name: "product name",
      price: "$20",
      para: "We believe in natural beauty",
    },
    {
      img: seller4,
      name: "product name",
      price: "$20",
      para: "We believe in natural beauty",
    },
    {
      img: seller3,
      name: "product name",
      price: "$20",
      para: "We believe in natural beauty",
    },
    {
      img: seller3,
      name: "product name",
      price: "$20",
      para: "We believe in natural beauty",
    },
    {
      img: seller4,
      name: "product name",
      price: "$20",
      para: "We believe in natural beauty",
    },
    {
      img: seller3,
      name: "product name",
      price: "$20",
      para: "We believe in natural beauty",
    },
    {
      img: seller3,
      name: "product name",
      price: "$20",
      para: "We believe in natural beauty",
    },
    {
      img: seller4,
      name: "product name",
      price: "$20",
      para: "We believe in natural beauty",
    },
  ];
  return (
    <>
      <Header />
      <PageHeader pagename="shop" />
      {/* <!-- shop-sec start here --> */}
      <section className="shop-sec">
        <div className="container">
          <div className="row">
            <div className="col-md-3">
              <div className="shop-category">
                <div className="shop-category-head">
                  <h3>Categories</h3>
                </div>
                <div className="accordion" id="accordionExample">
                  <div className="card">
                    <div className="card-header" id="headingOne">
                      <h2 className="mb-0 ">
                        <button
                          className="btn btn-link btn-block text-left"
                          type="button"
                          data-toggle="collapse"
                          data-target="#collapseOne"
                          aria-expanded="true"
                          aria-controls="collapseOne"
                        >
                          Candles{" "}
                          <span className="primary-color for-number">10</span>
                        </button>
                      </h2>
                    </div>

                    <div
                      id="collapseOne"
                      className="collapse show"
                      aria-labelledby="headingOne"
                      data-parent="#accordionExample"
                    >
                      <div className="card-body">
                        <ul className="card-body-ul">
                          <li>
                            <span>
                              {" "}
                              <li>10 Taper Candles</li>
                            </span>
                            <span>10</span>
                          </li>
                          <li>
                            <span>
                              {" "}
                              <li>10 Taper Candles</li>
                            </span>
                            <span>10</span>
                          </li>
                          <li>
                            <span>
                              {" "}
                              <li>10 Taper Candles</li>
                            </span>
                            <span>10</span>
                          </li>
                          <li>
                            <span>
                              {" "}
                              <li>10 Taper Candles</li>
                            </span>
                            <span>10</span>
                          </li>
                          <li>
                            <span>
                              {" "}
                              <li>10 Taper Candles</li>
                            </span>
                            <span>10</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="card">
                    <div className="card-header" id="headingTwo">
                      <h2 className="mb-0">
                        <button
                          className="btn btn-link btn-block text-left collapsed"
                          type="button"
                          data-toggle="collapse"
                          data-target="#collapseTwo"
                          aria-expanded="false"
                          aria-controls="collapseTwo"
                        >
                          Bath Salts{" "}
                          <span className="primary-color for-number">10</span>
                        </button>
                      </h2>
                    </div>
                    <div
                      id="collapseTwo"
                      className="collapse"
                      aria-labelledby="headingTwo"
                      data-parent="#accordionExample"
                    >
                      <div className="card-body">
                        <ul className="card-body-ul">
                          <li>
                            <span>
                              {" "}
                              <li>10 Taper Candles</li>
                            </span>
                            <span>10</span>
                          </li>
                          <li>
                            <span>
                              {" "}
                              <li>10 Taper Candles</li>
                            </span>
                            <span>10</span>
                          </li>
                          <li>
                            <span>
                              {" "}
                              <li>10 Taper Candles</li>
                            </span>
                            <span>10</span>
                          </li>
                          <li>
                            <span>
                              {" "}
                              <li>10 Taper Candles</li>
                            </span>
                            <span>10</span>
                          </li>
                          <li>
                            <span>
                              {" "}
                              <li>10 Taper Candles</li>
                            </span>
                            <span>10</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="card">
                    <div className="card-header" id="headingThree">
                      <h2 className="mb-0">
                        <button
                          className="btn btn-link btn-block text-left collapsed"
                          type="button"
                          data-toggle="collapse"
                          data-target="#collapseThree"
                          aria-expanded="false"
                          aria-controls="collapseThree"
                        >
                          Bath Soaps Washes{" "}
                          <span className="primary-color for-number">10</span>
                        </button>
                      </h2>
                    </div>
                    <div
                      id="collapseThree"
                      className="collapse"
                      aria-labelledby="headingThree"
                      data-parent="#accordionExample"
                    >
                      <div className="card-body">
                        <ul className="card-body-ul">
                          <li>
                            <span>
                              {" "}
                              <li>10 Taper Candles</li>
                            </span>
                            <span>10</span>
                          </li>
                          <li>
                            <span>
                              {" "}
                              <li>10 Taper Candles</li>
                            </span>
                            <span>10</span>
                          </li>
                          <li>
                            <span>
                              {" "}
                              <li>10 Taper Candles</li>
                            </span>
                            <span>10</span>
                          </li>
                          <li>
                            <span>
                              {" "}
                              <li>10 Taper Candles</li>
                            </span>
                            <span>10</span>
                          </li>
                          <li>
                            <span>
                              {" "}
                              <li>10 Taper Candles</li>
                            </span>
                            <span>10</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div className="card">
                    <div className="card-header" id="headingFour">
                      <h2 className="mb-0">
                        <button
                          className="btn btn-link btn-block text-left collapsed"
                          type="button"
                          data-toggle="collapse"
                          data-target="#collapseFour"
                          aria-expanded="false"
                          aria-controls="collapseFour"
                        >
                          Crystals{" "}
                          <span className="primary-color for-number">10</span>
                        </button>
                      </h2>
                    </div>
                    <div
                      id="collapseFour"
                      className="collapse"
                      aria-labelledby="headingFour"
                      data-parent="#accordionExample"
                    >
                      <div className="card-body">
                        <ul className="card-body-ul">
                          <li>
                            <span>
                              {" "}
                              <li>10 Taper Candles</li>
                            </span>
                            <span>10</span>
                          </li>
                          <li>
                            <span>
                              {" "}
                              <li>10 Taper Candles</li>
                            </span>
                            <span>10</span>
                          </li>
                          <li>
                            <span>
                              {" "}
                              <li>10 Taper Candles</li>
                            </span>
                            <span>10</span>
                          </li>
                          <li>
                            <span>
                              {" "}
                              <li>10 Taper Candles</li>
                            </span>
                            <span>10</span>
                          </li>
                          <li>
                            <span>
                              {" "}
                              <li>10 Taper Candles</li>
                            </span>
                            <span>10</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div className="card">
                    <div className="card-header" id="headingFive">
                      <h2 className="mb-0">
                        <button
                          className="btn btn-link btn-block text-left collapsed"
                          type="button"
                          data-toggle="collapse"
                          data-target="#collapseFive"
                          aria-expanded="false"
                          aria-controls="collapseFive"
                        >
                          Hair & Skin{" "}
                          <span className="primary-color for-number">10</span>
                        </button>
                      </h2>
                    </div>
                    <div
                      id="collapseFive"
                      className="collapse"
                      aria-labelledby="headingFive"
                      data-parent="#accordionExample"
                    >
                      <div className="card-body">
                        <ul className="card-body-ul">
                          <li>
                            <span>
                              {" "}
                              <li>10 Taper Candles</li>
                            </span>
                            <span>10</span>
                          </li>
                          <li>
                            <span>
                              {" "}
                              <li>10 Taper Candles</li>
                            </span>
                            <span>10</span>
                          </li>
                          <li>
                            <span>
                              {" "}
                              <li>10 Taper Candles</li>
                            </span>
                            <span>10</span>
                          </li>
                          <li>
                            <span>
                              {" "}
                              <li>10 Taper Candles</li>
                            </span>
                            <span>10</span>
                          </li>
                          <li>
                            <span>
                              {" "}
                              <li>10 Taper Candles</li>
                            </span>
                            <span>10</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div className="card">
                    <div className="card-header" id="headingSix">
                      <h2 className="mb-0">
                        <button
                          className="btn btn-link btn-block text-left collapsed"
                          type="button"
                          data-toggle="collapse"
                          data-target="#collapseSix"
                          aria-expanded="false"
                          aria-controls="collapseSix"
                        >
                          Incense{" "}
                          <span className="primary-color for-number">10</span>
                        </button>
                      </h2>
                    </div>
                    <div
                      id="collapseSix"
                      className="collapse"
                      aria-labelledby="headingSix"
                      data-parent="#accordionExample"
                    >
                      <div className="card-body">
                        <ul className="card-body-ul">
                          <li>
                            <span>
                              {" "}
                              <li>10 Taper Candles</li>
                            </span>
                            <span>10</span>
                          </li>
                          <li>
                            <span>
                              {" "}
                              <li>10 Taper Candles</li>
                            </span>
                            <span>10</span>
                          </li>
                          <li>
                            <span>
                              {" "}
                              <li>10 Taper Candles</li>
                            </span>
                            <span>10</span>
                          </li>
                          <li>
                            <span>
                              {" "}
                              <li>10 Taper Candles</li>
                            </span>
                            <span>10</span>
                          </li>
                          <li>
                            <span>
                              {" "}
                              <li>10 Taper Candles</li>
                            </span>
                            <span>10</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div className="card">
                    <div className="card-header" id="headingSeven">
                      <h2 className="mb-0">
                        <button
                          className="btn btn-link btn-block text-left collapsed"
                          type="button"
                          data-toggle="collapse"
                          data-target="#collapseSeven"
                          aria-expanded="false"
                          aria-controls="collapseSeven"
                        >
                          Oil Burners{" "}
                          <span className="primary-color for-number">10</span>
                        </button>
                      </h2>
                    </div>
                    <div
                      id="collapseSeven"
                      className="collapse"
                      aria-labelledby="headingSeven"
                      data-parent="#accordionExample"
                    >
                      <div className="card-body">
                        <ul className="card-body-ul">
                          <li>
                            <span>
                              {" "}
                              <li>10 Taper Candles</li>
                            </span>
                            <span>10</span>
                          </li>
                          <li>
                            <span>
                              {" "}
                              <li>10 Taper Candles</li>
                            </span>
                            <span>10</span>
                          </li>
                          <li>
                            <span>
                              {" "}
                              <li>10 Taper Candles</li>
                            </span>
                            <span>10</span>
                          </li>
                          <li>
                            <span>
                              {" "}
                              <li>10 Taper Candles</li>
                            </span>
                            <span>10</span>
                          </li>
                          <li>
                            <span>
                              {" "}
                              <li>10 Taper Candles</li>
                            </span>
                            <span>10</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div className="card">
                    <div className="card-header" id="headingEight">
                      <h2 className="mb-0">
                        <button
                          className="btn btn-link btn-block text-left collapsed"
                          type="button"
                          data-toggle="collapse"
                          data-target="#collapseEight"
                          aria-expanded="false"
                          aria-controls="collapseEight"
                        >
                          Oils & Essences{" "}
                          <span className="primary-color for-number">10</span>
                        </button>
                      </h2>
                    </div>
                    <div
                      id="collapseEight"
                      className="collapse"
                      aria-labelledby="headingEight"
                      data-parent="#accordionExample"
                    >
                      <div className="card-body">
                        <ul className="card-body-ul">
                          <li>
                            <span>
                              {" "}
                              <li>10 Taper Candles</li>
                            </span>
                            <span>10</span>
                          </li>
                          <li>
                            <span>
                              {" "}
                              <li>10 Taper Candles</li>
                            </span>
                            <span>10</span>
                          </li>
                          <li>
                            <span>
                              {" "}
                              <li>10 Taper Candles</li>
                            </span>
                            <span>10</span>
                          </li>
                          <li>
                            <span>
                              {" "}
                              <li>10 Taper Candles</li>
                            </span>
                            <span>10</span>
                          </li>
                          <li>
                            <span>
                              {" "}
                              <li>10 Taper Candles</li>
                            </span>
                            <span>10</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div className="card">
                    <div className="card-header" id="headingNine">
                      <h2 className="mb-0">
                        <button
                          className="btn btn-link btn-block text-left collapsed"
                          type="button"
                          data-toggle="collapse"
                          data-target="#collapseNine"
                          aria-expanded="false"
                          aria-controls="collapseNine"
                        >
                          Powder & Sachets{" "}
                          <span className="primary-color for-number">10</span>
                        </button>
                      </h2>
                    </div>
                    <div
                      id="collapseNine"
                      className="collapse"
                      aria-labelledby="headingNine"
                      data-parent="#accordionExample"
                    >
                      <div className="card-body">
                        <ul className="card-body-ul">
                          <li>
                            <span>
                              {" "}
                              <li>10 Taper Candles</li>
                            </span>
                            <span>10</span>
                          </li>
                          <li>
                            <span>
                              {" "}
                              <li>10 Taper Candles</li>
                            </span>
                            <span>10</span>
                          </li>
                          <li>
                            <span>
                              {" "}
                              <li>10 Taper Candles</li>
                            </span>
                            <span>10</span>
                          </li>
                          <li>
                            <span>
                              {" "}
                              <li>10 Taper Candles</li>
                            </span>
                            <span>10</span>
                          </li>
                          <li>
                            <span>
                              {" "}
                              <li>10 Taper Candles</li>
                            </span>
                            <span>10</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div className="card">
                    <div className="card-header" id="headingTenth">
                      <h2 className="mb-0">
                        <button
                          className="btn btn-link btn-block text-left collapsed"
                          type="button"
                          data-toggle="collapse"
                          data-target="#collapseTenth"
                          aria-expanded="false"
                          aria-controls="collapseTenth"
                        >
                          Statues & Figures{" "}
                          <span className="primary-color for-number">10</span>
                        </button>
                      </h2>
                    </div>
                    <div
                      id="collapseTenth"
                      className="collapse"
                      aria-labelledby="headingTenth"
                      data-parent="#accordionExample"
                    >
                      <div className="card-body">
                        <ul className="card-body-ul">
                          <li>
                            <span>
                              {" "}
                              <li>10 Taper Candles</li>
                            </span>
                            <span>10</span>
                          </li>
                          <li>
                            <span>
                              {" "}
                              <li>10 Taper Candles</li>
                            </span>
                            <span>10</span>
                          </li>
                          <li>
                            <span>
                              {" "}
                              <li>10 Taper Candles</li>
                            </span>
                            <span>10</span>
                          </li>
                          <li>
                            <span>
                              {" "}
                              <li>10 Taper Candles</li>
                            </span>
                            <span>10</span>
                          </li>
                          <li>
                            <span>
                              {" "}
                              <li>10 Taper Candles</li>
                            </span>
                            <span>10</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div className="card">
                    <div className="card-header" id="headingeleven">
                      <h2 className="mb-0">
                        <button
                          className="btn btn-link btn-block text-left collapsed"
                          type="button"
                          data-toggle="collapse"
                          data-target="#collapseEleven"
                          aria-expanded="false"
                          aria-controls="collapseEleven"
                        >
                          Religious Figures{" "}
                          <span className="primary-color for-number">10</span>
                        </button>
                      </h2>
                    </div>
                    <div
                      id="collapseEleven"
                      className="collapse"
                      aria-labelledby="headingEleven"
                      data-parent="#accordionExample"
                    >
                      <div className="card-body">
                        <ul className="card-body-ul">
                          <li>
                            <span>
                              {" "}
                              <li>10 Taper Candles</li>
                            </span>
                            <span>10</span>
                          </li>
                          <li>
                            <span>
                              {" "}
                              <li>10 Taper Candles</li>
                            </span>
                            <span>10</span>
                          </li>
                          <li>
                            <span>
                              {" "}
                              <li>10 Taper Candles</li>
                            </span>
                            <span>10</span>
                          </li>
                          <li>
                            <span>
                              {" "}
                              <li>10 Taper Candles</li>
                            </span>
                            <span>10</span>
                          </li>
                          <li>
                            <span>
                              {" "}
                              <li>10 Taper Candles</li>
                            </span>
                            <span>10</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-9">
              <div className="shop-dv-section">
                {/* Best Seller */}
                <section className="shop-seller">
                  <div className="row">
                    {sellerstuff?.map((data, sellerindex) => {
                      console.log(data?.img);
                      return (
                        <>
                          <div className="col-md-4" key={sellerindex}>
                            <Link to="/shop-detail">
                              <div className="seller-all">
                                <div className="seller-img">
                                  <img
                                    src={data?.img}
                                    style={{ height: "unset" }}
                                    className="img-fluid"
                                  />
                                  <div className="add-to-cart">
                                    <span className="primary-color">
                                      {" "}
                                      <i
                                        class="fa fa-shopping-basket"
                                        aria-hidden="true"
                                      ></i>
                                      <button className="priamry-color">
                                        {" "}
                                        <Link
                                          to="/cart"
                                          className="cart-add-to"
                                        >
                                          add to cart
                                        </Link>
                                      </button>
                                    </span>
                                    <span className="primary-color primary-heart">
                                      <i
                                        class="fa fa-heart"
                                        aria-hidden="true"
                                      ></i>
                                    </span>
                                  </div>
                                </div>
                                <div className="seller-head-para">
                                  <h3 className="primary-color">
                                    {data?.name} <span> | {data?.price}</span>
                                  </h3>
                                  <p>{data?.para}</p>
                                </div>
                                <div className="seller-stars">
                                  <ul>
                                    <li>
                                      <i
                                        class="fa fa-star primary-color"
                                        aria-hidden="true"
                                      ></i>
                                    </li>
                                    <li>
                                      <i
                                        class="fa fa-star primary-color"
                                        aria-hidden="true"
                                      ></i>
                                    </li>
                                    <li>
                                      <i
                                        class="fa fa-star primary-color"
                                        aria-hidden="true"
                                      ></i>
                                    </li>
                                    <li>
                                      <i
                                        class="fa fa-star primary-color"
                                        aria-hidden="true"
                                      ></i>
                                    </li>
                                    <li>
                                      <i
                                        class="fa fa-star extra-color-6"
                                        aria-hidden="true"
                                      ></i>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </Link>
                          </div>
                        </>
                      );
                    })}
                  </div>
                </section>
                {/* ================= */}
              </div>

              <Pagination />
            </div>
          </div>
        </div>
      </section>
      {/* <!-- shop-sec end here  --> */}

      <Footer />
    </>
  );
}

export default Shop;
